import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationDialogComponent } from './location-dialog.component';
import { IntervalComponent } from '../interval/interval.component';
import { PracticeCasesService } from '../../ccs-module/services/practice-cases.service';
import { CcsService } from '../../services/ccs.service';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from './can-deactivate.guard';

@Component({
  selector: 'app-launch-case',
  templateUrl: './launch-case.component.html',
  styleUrls: ['./launch-case.component.scss']
})
export class LaunchCaseComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  // Add case ID property
  caseId: string = '1'; // Default to '1' if no parameter is provided
  
  elapsedTime = { days: 0, hours: 0, minutes: 0 };
  remainingTime = { minutes: 20, seconds: 0 };
  maxAllottedTime = '18 minutes + 2 minutes for case-end orders';
  showInterval = false;
  currentLocation = 'Office'; // Default location
  showLocationDialog = false;
  showOrders=false;
  vitalContent:any;
  physicalEvaluations: any[] = []; // New property to store physical evaluations
  // Dialog related properties
  showIntroductionDialog = false;
  showHistoryDialog = false;
  showVitalsDialog = false;
  caseData: any = {};
  evaluationsResponse=[]
  orderList:any;
  showClockDialog = false;

  // Add end case confirmation dialog property
  showEndCaseConfirmation = false;

  calendar: number[][] = [];
  selectedDay: number | null = null;
  
  // Time simulation properties
  selectedOption: 'on' | 'in' | 'nextresult' | 'asneeded' = 'on';
  showTimeSpinners = true;
  simulationTime = {
    days: 0,
    hours: 0,
    minutes: 0
  };
  currentDayOfWeek = 'Thu'; // This will be dynamic based on selected day

  // Add case time properties
  currentCaseDay = 1;
  currentCaseTime = '00:00';

  // Time simulation properties
  showAdvanceConfirmation = false;
  targetSimulation = {
    days: 1,
    hours: 0,
    minutes: 0
  };

  showTimeError = false;
  isTimeValid = true;

  caseConditionList = []
  showConditionPopup = false;
  currentCondition = '';
  shownConditions: Set<number> = new Set(); // Track which conditions have been shown

  // Location image mapping
  locationImages: { [key: string]: string } = {
    'Emergency Department': 'assets/emergency.png',
    'Home': 'assets/home.png',
    'Intensive Care Unit': 'assets/icu.png',
    'Inpatient Unit': 'assets/ward.png',
    'Office': 'assets/office.png'
  };

  showLocationOrdersDialog = false;
  pendingLocation: string | null = null;
  selectedOrders: any[] = [];
  isOutpatientLocation: boolean = false;

  // Add new properties for tracking vital signs and progress notes
  vitalSignsHistory: any[] = [];
  progressNotes: any[] = [];

  // Add new properties for order responses
  showOrderResponsePopup = false;
  currentOrderResponse: string = '';
  currentOrderName: string = '';
  pendingOrderResponses: any[] = [];
  showOverlayLoader=false;
  selectedSimulationTime: any = null;

  // Add properties for no orders available dialog
  showNoOrdersDialog = false;

  // Add timer properties
  private realTimeTimer: any;
  private totalRealTimeInSeconds = 20 * 60; // 20 minutes in seconds
  private currentRealTimeInSeconds = 20 * 60; // Start with 20 minutes
  showTimeExpiredDialog = false;
  
  // Track initial simulation time for elapsed calculation
  private initialCaseDay = 1;
  private initialCaseTime = '00:00';

  // Case-end instructions properties
  showCaseEndInstructions = false;
  isCaseEndPhase = false;
  private caseEndInstructionsShown = false;
  private isLoadingFromSavedState = false;

  // Local storage keys for state management
  private readonly SELECTED_ORDERS_KEY = 'launch_case_selected_orders';
  private readonly CASE_STATE_KEY = 'launch_case_state';

  // Navigation confirmation properties
  private isNavigatingAway = false;
  private pendingNavigation: (() => void) | null = null;
  private navigationPromiseResolve: ((value: boolean) => void) | null = null;
  private isPageRefreshAttempt = false;

  // New properties for order management coordination
  selectedOrderIds: number[] = []; // Track IDs of selected orders
  cancelledOrders: any[] = []; // Track cancelled orders to restore

  // New properties for "Call/See me as needed" option
  pendingAsNeededContinuation: { conditions: any[], nextIndex: number } | null = null;

  // Track preOrders from backend
  preOrders: number[] = [];

  // Add property for patient intervals
  patientIntervals: any[] = [];

  // New properties for day-by-day as needed option
  pendingDayByDayContinuation: {
    day: number,
    pendingOrders: any[],
    dayConditions: any[],
    orderIndex: number,
    conditionIndex: number
  } | null = null;

  // Track pending On/In day-by-day continuation
  pendingOnInContinuation: {
    day: number,
    pendingOrders: any[],
    dayConditions: any[],
    orderIndex: number,
    conditionIndex: number,
    maxDay: number
  } | null = null;

  // New properties for Exit Case functionality
  showDiagnosisDialog = false;
  showThankYouDialog = false;
  diagnosisText = '';
  private thankYouTimer: any;

  constructor(
    private caseService: CcsService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Get case ID from route parameters first
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.caseId = params['id'];
       
      }
      
      // Initialize everything after case ID is set
      this.initializeComponent();
    });


  }

  private async initializeComponent(): Promise<void> {
    

    this.generateCalendar()
    this.showOverlayLoader=true;
    this.getPhysicalEvaluations(); 
 
    // Initialize timer logic here
   
    this.getCaseDetails();
   // Add call to fetch physical evaluations
 
    
    // Start the real-time countdown timer
    this.startRealTimeTimer();
    
    // Load saved state after a short delay to ensure components are initialized
    setTimeout(() => {
      this.loadSavedState();
    }, 100);
  }

  getCaseDetails(){
    this.caseService.getCaseDetails(this.caseId).subscribe(async (data:any)=>{
      this.caseData = data;
      
      this.currentLocation = this.caseData.location;

      //set time of the case it will be in this foramte 
      //  '18 minutes + 2 minutes for case-end orders';
      this.maxAllottedTime = `${this.caseData.estimated_duration-2} + 2 minutes for case-end orders`;
      
      console.log('=== Case Conditions Debug ===');
      console.log('Raw case_conditions:', this.caseData.case_conditions);
      
      this.caseConditionList = JSON.parse(this.caseData.case_conditions)
      
      console.log('Parsed case conditions:', this.caseConditionList);
      
      for (let item of this.caseConditionList)
      {
        console.log('Processing condition item:', item);
        
        item.elapsedDay = item.day;
        item.elapsedTime = item.time;
        item.orderId = item.linkedOrders;
        
        // Add missing caseConditionValue property for backward compatibility
        // Assume all conditions are "Condition" type unless specified otherwise
        item.caseConditionValue = item.caseConditionValue || "Condition";
        
        console.log('Processed condition:', {
          elapsedDay: item.elapsedDay,
          elapsedTime: item.elapsedTime,
          description: item.description,
          caseConditionValue: item.caseConditionValue,
          orderId: item.orderId
        });
      }

      console.log('Final case condition list:', this.caseConditionList);

      // Parse patient intervals
      console.log('=== Patient Intervals Debug ===');
      console.log('Raw patient_interval:', this.caseData.patient_interval);
      
      if (this.caseData.patient_interval) {
        try {
          if (typeof this.caseData.patient_interval === 'string') {
            this.patientIntervals = JSON.parse(this.caseData.patient_interval);
          } else if (Array.isArray(this.caseData.patient_interval)) {
            this.patientIntervals = this.caseData.patient_interval;
          }
          console.log('Parsed patient intervals:', this.patientIntervals);
        } catch (e) {
          console.error('Error parsing patient_interval:', e);
          this.patientIntervals = [];
        }
      } else {
        this.patientIntervals = [];
        console.log('No patient intervals found');
      }

      // Format the time from "1300" to "13:00"
      const timeString = data.case_Time || '0000';
      const hours = timeString.substring(0, 2);
      const minutes = timeString.substring(2, 4);
      this.currentCaseTime = `${hours}:${minutes}`;
      
      // Store initial time for elapsed calculation
      this.initialCaseTime = this.currentCaseTime;
     
      this.initialCaseDay = this.currentCaseDay;


      await this.getOrderDetails()

      // Process preOrders after orderList is loaded
      if (this.caseData.preOrders) {
        this.processPreOrders(this.caseData.preOrders);
      }

      if (this.caseData.linkedOrders && this.caseData.linkedOrders.length > 0)  
        {
  
          this.calculateOrderTiming(this.caseData.linkedOrders);
            // update the response of the linked orders from the order list here
            console.log('this.caseData.linkedOrders',this.caseData.linkedOrders)
            this.caseData.linkedOrders.forEach((linkedOrder: any) => {
              const matchedOrder = this.orderList.find((order: any) => order.id === linkedOrder.id);
              if (matchedOrder) {
                console.log('matchedOrder',matchedOrder)
                matchedOrder.response = linkedOrder.customResponse;
                matchedOrder.orderDay = linkedOrder.orderDay;
                matchedOrder.returnTime = linkedOrder.returnTime;
              }
            });
  
            // Apply time calculations to linked orders as well
           
            // console.log('this.caseData.linkedOrders:', this.caseData.linkedOrders);
        }
      
      this.evaluationsResponse = this.caseData.evaluations;
      
      this.vitalContent = this.generateVitalsTable(JSON.parse(this.caseData.baseline_vitals));
      
      // Add introduction to progress notes
      this.addToProgressNotes('Introduction', this.caseData.Introduction);
      
      // Show first dialog after data is loaded
      this.showIntroductionDialog = true;

    this.showOverlayLoader=false;
    })
  }

  private processPreOrders(preOrdersString: string): void {
    try {
      console.log('=== Processing Pre-Orders ===');
      console.log('Raw preOrders string:', preOrdersString);
      
      // Parse the preOrders JSON string
      let preOrderIds: number[] = [];
      if (typeof preOrdersString === 'string') {
        preOrderIds = JSON.parse(preOrdersString);
      } else if (Array.isArray(preOrdersString)) {
        preOrderIds = preOrdersString;
      }
      
      console.log('Parsed preOrder IDs:', preOrderIds);
      
      if (preOrderIds.length === 0) {
        console.log('No pre-orders to process');
        return;
      }
      
      // Store preOrders for tracking
      this.preOrders = preOrderIds;
      
      // Filter matching orders from orderList
      const matchingOrders = this.orderList.filter((order: any) => 
        preOrderIds.includes(order.id)
      );
      
      console.log('Matching orders found:', matchingOrders);
      
      if (matchingOrders.length === 0) {
        console.log('No matching orders found in orderList');
        return;
      }
      
      // Add timing information and prepare orders for selectedOrders
      const preOrdersWithTiming = matchingOrders.map((order: any) => ({
        ...order,
        orderTime: 'Day 1 @ 00:00',
        reportTime: 'Day 1 @ 00:00', 
        orderDay: '1',
        orderReturnTime: '0000',
        responseShown: false
      }));
      
      console.log('Pre-orders with timing:', preOrdersWithTiming);
      
      // Add to selectedOrders array
      this.selectedOrders = [...(this.selectedOrders || []), ...preOrdersWithTiming];
      
      // Update selectedOrderIds to track these orders
      this.selectedOrderIds = [...(this.selectedOrderIds || []), ...preOrderIds];
      
      console.log('Updated selectedOrders:', this.selectedOrders);
      console.log('Updated selectedOrderIds:', this.selectedOrderIds);
      
      // Emit the updated orders to the orders component
      this.onOrdersUpdated(this.selectedOrders);
      
    } catch (error) {
      console.error('Error processing pre-orders:', error);
    }
  }

  onIntroductionDialogClose() {
    this.showIntroductionDialog = false;
    // Show history dialog after introduction is closed
    setTimeout(() => {
      // Add history to progress notes when showing history dialog
      this.addToProgressNotes('History of Present Illness', this.caseData.past_medical_history);
      this.showHistoryDialog = true;
    }, 300);
  }

  onHistoryDialogClose() {
    this.showHistoryDialog = false;
    // Show vitals dialog after history is closed
    setTimeout(() => {
      // Don't add vital signs to history here - only when dialog is actually shown
      this.showVitalsDialog = true;
      // Add vital signs to history whenever vitals dialog is shown
    if (this.caseData && this.caseData.baseline_vitals) {
      this.addToVitalSignsHistory(JSON.parse(this.caseData.baseline_vitals));
    }
    }, 300);
  }

  onVitalsDialogClose() {
    this.showVitalsDialog = false;
    
    
    
    if (this.pendingLocation) {
      // Finally update the location
      this.currentLocation = this.pendingLocation;
      this.pendingLocation = null;
    }
  }

  onHelpClick(): void {
    // Implement help functionality
  }

  onAboutClick(): void {
    // Implement about functionality
  }

  onEndCaseClick(): void {
    // Show confirmation dialog before ending the case
    this.showEndCaseConfirmation = true;
  }

  // Handle end case confirmation - Yes action
  onEndCaseConfirm(): void {
    
    // Clear saved state when case is manually ended
    this.clearSavedState();
    
    // Close the confirmation dialog
    this.showEndCaseConfirmation = false;
    
    // If this is a page refresh attempt, allow the page to reload
    if (this.isPageRefreshAttempt) {
      this.isNavigatingAway = true;
      this.isPageRefreshAttempt = false;
      // Use setTimeout to ensure dialog closes before reload
      setTimeout(() => {
        window.location.reload();
      }, 100);
      return;
    }
    
    // If this is a navigation attempt, execute the pending navigation
    if (this.pendingNavigation) {
      this.pendingNavigation();
      this.pendingNavigation = null;
      this.navigationPromiseResolve = null;
      return;
    }
    
    // Otherwise, it's the end case button - navigate back to interactive cases
    this.isNavigatingAway = true;
    this.router.navigate(['/ccs-module'], { 
      queryParams: { section: 'interactive-cases' } 
    });
  }

  // Handle end case cancellation - No action
  onEndCaseCancel(): void {
    
    // Close the confirmation dialog
    this.showEndCaseConfirmation = false;
    
    // If this is a page refresh attempt, just reset the flag
    if (this.isPageRefreshAttempt) {
      this.isPageRefreshAttempt = false;
      return;
    }
    
    // If this is a navigation attempt, reject it
    if (this.pendingNavigation) {
      this.pendingNavigation = null;
      if (this.navigationPromiseResolve) {
        this.navigationPromiseResolve(false); // User cancelled navigation
        this.navigationPromiseResolve = null;
      }
    }
  }

  onIntervalClick(): void {
    this.showInterval = true;
    this.showOrders = false;
    this.showLocationDialog = false;
    this.showClockDialog = false;
  }

  onIntervalTimeAdvance(timeData: {days: number, hours: number, minutes: number}): void {
    // Update the current case time and day
    this.currentCaseDay = timeData.days;
    const formattedHours = timeData.hours.toString().padStart(2, '0');
    const formattedMinutes = timeData.minutes.toString().padStart(2, '0');
    this.currentCaseTime = `${formattedHours}:${formattedMinutes}`;
    
    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();
    
    // Check if we've reached the maximum day in case conditions
    this.checkForMaximumElapsedDay();
    
    // Save case state after time advancement
    this.saveCaseState();
    
    // Close interval dialog
    // this.showInterval = false;
  }

  openOrders()
  {
    
    this.showOrders = !this.showOrders;
  
    if (this.showOrders) {
      this.showLocationDialog = false; // Close location dialog if open
      
      // Load saved orders when orders component is opened
      setTimeout(() => {
        this.loadSelectedOrders();
      }, 50);
    }
  }

  openLocationDialog(): void {
    this.showLocationDialog = true;
    // this.showInterval = false;
  }

  onLocationSelected(location: string): void {
    this.currentLocation = location;
    this.showLocationDialog = false;
    // Save case state after location change
    this.saveCaseState();
  }

  onShowOrdersDialog(data: {location: string, isOutpatient: boolean}): void {
    this.pendingLocation = data.location;
    this.isOutpatientLocation = data.isOutpatient;
    this.showLocationOrdersDialog = true;
  }

  onOpenTimeSelection(): void {
    this.showClockDialog = true;
  }

  onTimeSelected(simulationTime: any): void {
    if (this.showLocationOrdersDialog) {
      // If selecting time for location change, just store it
      this.selectedSimulationTime = {...simulationTime};
      this.showClockDialog = false;
    } else {
      // Check if "With next available result" option is selected
      if (this.selectedOption === 'nextresult') {
        this.handleNextAvailableResult();
        return;
      }
      
      // Check if "Call/See me as needed" option is selected
      if (this.selectedOption === 'asneeded') {
        this.handleAsNeededOption();
        return;
      }
      
      // For "On" and "In" options, change location to Home
      if (this.selectedOption === 'on' || this.selectedOption === 'in') {
        this.currentLocation = 'Home';
        console.log('Location changed to Home for option:', this.selectedOption);
      }
      
      // For normal clock simulation, use the original logic
      this.simulationTime = simulationTime;
      if (this.isValidTimeSimulation()) {
        // Calculate target simulation based on option
        if (this.selectedOption === 'in') {
          // For "In" option: Convert relative duration to absolute target time
          this.targetSimulation = {
            days: this.currentCaseDay + simulationTime.days,
            hours: simulationTime.hours,
            minutes: simulationTime.minutes
          };
          console.log('In option - Target simulation:', this.targetSimulation);
        } else {
          // For "On" and other options: Use absolute time directly
          this.targetSimulation = {...simulationTime};
          console.log('On option - Target simulation:', this.targetSimulation);
        }
        
        // Close the clock dialog first
        this.showClockDialog = false;
        
        // Check if we should use day-by-day simulation for "On" and "In" options
        if ((this.selectedOption === 'on' || this.selectedOption === 'in') && 
            this.caseData.maxSimulatedTime && 
            this.caseData.maxSimulatedTime > 0 &&
            this.targetSimulation.days > this.currentCaseDay) {
          
          console.log('=== Using Day-by-Day Simulation for', this.selectedOption.toUpperCase(), 'option ===');
          console.log('Target days:', this.targetSimulation.days, 'Current day:', this.currentCaseDay);
          console.log('maxSimulatedTime:', this.caseData.maxSimulatedTime);
          
          // Use day-by-day simulation up to target day (but not beyond maxSimulatedTime)
          const maxDay = Math.min(this.targetSimulation.days, this.caseData.maxSimulatedTime);
          this.handleOnInDayByDaySimulation(maxDay, this.targetSimulation);
          return;
        }
        
        // Fall back to original logic for single day or when maxSimulatedTime not available
        if (this.targetSimulation.days > this.currentCaseDay) {
          console.log('Using original checkDayCondition logic');
          this.checkDayCondition();
        } else {
          this.applyTimeSimulation();
        }
      } else {
        this.showTimeError = true;
        this.showClockDialog = false;
      }
    }
  }

  onLocationOrdersConfirm(data: { appointmentTime?: string }): void {
    if (this.isOutpatientLocation && this.selectedSimulationTime) {
      // For outpatient locations, simulate to the selected time
      this.simulationTime = {...this.selectedSimulationTime};
      if (this.isValidTimeSimulation()) {
        this.targetSimulation = {...this.selectedSimulationTime};
        if (this.targetSimulation.days > this.currentCaseDay) {
          this.checkDayCondition();
        } else {
          this.applyTimeSimulation();
        }
      }
    }
    
    this.showLocationOrdersDialog = false;
    
    // Show vitals dialog after location change is confirmed
    if (this.pendingLocation) {
      this.showVitalsDialog = true;
      // Add vital signs to history whenever vitals dialog is shown
    if (this.caseData && this.caseData.baseline_vitals) {
      this.addToVitalSignsHistory(JSON.parse(this.caseData.baseline_vitals));
    }
    }
    
    // Reset the selected simulation time
    this.selectedSimulationTime = null;
  }

  generateVitalsTable(data: {
    bmi: string;
    diastolicBP: number;
    bpDiastolicUpright?: number;
    systolicBP: number;
    bpSystolicUpright?: number;
    caseDay: number;
    caseTime: string;
    height: number;
    pulse: number;
    pulseQuality: string;
    respiratoryRate: number;
    temperature: number;
    weight: number;
  }): string {



  

    const timeFormatted = `${data.caseTime.slice(0, 2)}:${data.caseTime.slice(2)}`;
    const temperatureF = ((data.temperature * 9) / 5 + 32).toFixed(1);
    const heightInInches = (data.height / 2.54).toFixed(1);
    const weightInLbs = (data.weight * 2.20462).toFixed(1);
  
    return `
    <div class="style3">
      <b>Initial Vital Signs</b> 
      <span style="padding-left:200px;" class="ng-binding">
        Day ${data.caseDay} @ ${timeFormatted}
      </span><br><br>
      <table>
        <tbody class="ng-scope">
          <tr>
            <td align="right">Temperature :</td>
            <td class="ng-binding">${data.temperature} degrees C (${temperatureF} degrees F)</td>
          </tr>
          <tr>
            <td align="right">Pulse :</td>
            <td class="ng-binding">${data.pulse} beats/minute <br> ${data.pulseQuality}</td>
          </tr>
          <tr>
            <td align="right">Respiratory rate :</td>
            <td class="ng-binding">${data.respiratoryRate} /minute</td>
          </tr>
          <tr>
            <td align="right">Blood Pressure, Systolic :</td>
            <td class="ng-binding">${data.systolicBP} mm Hg</td>
          </tr>
          <tr>
            <td align="right">Blood Presuure, Diastolic :</td>
            <td class="ng-binding">${data.diastolicBP} mm Hg</td>
          </tr>
          <tr>
            <td align="right">Height :</td>
            <td class="ng-binding">${data.height} cm (${heightInInches} in)</td>
          </tr>
          <tr>
            <td align="right">Weight :</td>
            <td class="ng-binding">${data.weight} kg (${weightInLbs} lb)</td>
          </tr>
          <tr>
            <td align="right">Body Mass Index :</td>
            <td class="ng-binding">${data.bmi} kg/m2</td>
          </tr>
        </tbody>
      </table>
    </div>
    `;
  }

  getPhysicalEvaluations() {
    this.caseService.getPhysicalEvaluations().subscribe({
      next: (data: any) => {
    
        this.physicalEvaluations = data;
        
      },
      error: (error) => {
        console.error('Error fetching physical evaluations:', error);
      }
    });
  }

  getOrderDetails() {


   return new Promise((resolve, reject) => {
    this.caseService.getOrderDetails().subscribe({
      next: (data :any) => {
        // Access the data like:
     
      this.orderList = data.data;
      
      // Apply time calculations to all orders - REMOVED: Now calculated on-demand when selected
      // this.calculateOrderTiming(this.orderList);
      
     
        const orderCategories = data.orderCategories;
        const orderTypes = data.orderTypes;
        resolve({ orderList: this.orderList, orderCategories, orderTypes });
      },
      error: (error) => {
        console.error('Error fetching order details:', error);
        reject(error);
      }
    });
   })
   
  }

  onClockClick(): void {
    this.showClockDialog = true;
    // this.showInterval = false; // Close other dialogs
    // this.showOrders = false;
    this.showLocationDialog = false;
    // Initialize spinners with current time
    this.initializeTimeSpinners();
  }

  onClockDialogClose(): void {
    this.showClockDialog = false;
  }

  generateCalendar() {
    // Generate calendar data (7 columns x 6 rows visible at a time)
    this.calendar = [];
    let currentRow: number[] = [];
    
    for (let i = 1; i <= 999; i++) {
      currentRow.push(i);
      
      if (currentRow.length === 7) {
        this.calendar.push(currentRow);
        currentRow = [];
      }
    }
    
    // Add remaining numbers if any
    if (currentRow.length > 0) {
      while (currentRow.length < 7) {
        currentRow.push(0); // Fill with zeros to complete the row
      }
      this.calendar.push(currentRow);
    }
  }

  onDayClick(day: number) {
    if (day > 0) {
      if (this.selectedOption === 'on') {
        // For "On" option: Direct day selection
        this.selectedDay = day;
        this.simulationTime.days = day;
        console.log('On option - Selected day:', day);
      } else if (this.selectedOption === 'in') {
        // For "In" option: Calculate duration from current day
        const duration = day - this.currentCaseDay;
        if (duration > 0) {
          this.selectedDay = day;
          this.simulationTime.days = duration; // Input field shows duration
          console.log('In option - Target day:', day, 'Duration:', duration);
        } else {
          // Invalid selection - can't go backward
          console.log('Invalid day selection for "In" option - cannot go backward');
          return;
        }
      } else {
        // For other options (nextresult, asneeded): use existing logic
        this.selectedDay = day;
        this.simulationTime.days = day;
      }
      
      // Validate the time after day selection
      this.isTimeValid = this.isValidTimeSimulation();
    }
  }

  onClose() {
    this.showClockDialog =false;
  }

  onSimulationOptionChange(option: 'on' | 'in' | 'nextresult' | 'asneeded') {
    this.selectedOption = option;
    this.showTimeSpinners = option === 'on' || option === 'in';
    
    // Reinitialize spinners when option changes to ensure correct display
    if (this.showTimeSpinners) {
      this.initializeTimeSpinners();
    }
  }

  onDayChange(value: number) {
    // Convert value to number to ensure proper arithmetic (not string concatenation)
    const numericValue = Number(value);
    
    if (numericValue >= 0 && numericValue <= 999) {
      if (this.selectedOption === 'on') {
        // For "On" option: Direct day input
        this.simulationTime.days = numericValue;
        this.selectedDay = numericValue; // Calendar highlights the entered day
        console.log('On option - Input day:', numericValue);
      } else if (this.selectedOption === 'in') {
        // For "In" option: Duration input, calculate target day
        if (numericValue > 0) { // Must be positive duration
          this.simulationTime.days = numericValue; // Input shows duration
          this.selectedDay = this.currentCaseDay + numericValue; // Calendar highlights target day
          console.log('In option - Duration:', numericValue, 'Target day:', this.selectedDay);
        } else {
          // Invalid duration - must be positive
          console.log('Invalid duration for "In" option - must be positive');
          this.selectedDay = null; // Clear calendar selection
        }
      } else {
        // For other options: use existing logic
        this.simulationTime.days = numericValue;
        this.selectedDay = numericValue;
      }
      
      // Validate the time after input change
      this.isTimeValid = this.isValidTimeSimulation();
    }
  }

  onHourChange(value: number) {
    // Convert value to number to ensure proper arithmetic
    const numericValue = Number(value);
    
    if (numericValue >= 0 && numericValue <= 23) {
      this.simulationTime.hours = numericValue;
      this.isTimeValid = this.isValidTimeSimulation();
    }
  }

  onMinuteChange(value: number) {
    // Convert value to number to ensure proper arithmetic
    const numericValue = Number(value);
    
    if (numericValue >= 0 && numericValue <= 59) {
      this.simulationTime.minutes = numericValue;
      this.isTimeValid = this.isValidTimeSimulation();
    }
  }

  // Add helper method to format case time
  formatCaseTime(): string {
    return `Day ${this.currentCaseDay} @ ${this.currentCaseTime}`;
  }

  initializeTimeSpinners() {
    // Parse current time (now in HH:MM format)
    const [hours, minutes] = this.currentCaseTime.split(':').map(Number);
    
    if (this.selectedOption === 'on') {
      // For "On" option: Initialize with current absolute time
      this.simulationTime = {
        days: this.currentCaseDay,
        hours: hours,
        minutes: minutes
      };
      this.selectedDay = this.currentCaseDay;
      console.log('Initialized "On" option with current time:', this.simulationTime);
    } else if (this.selectedOption === 'in') {
      // For "In" option: Initialize with zero duration (relative time)
      this.simulationTime = {
        days: 0, // Start with 0 duration
        hours: 0,
        minutes: 0
      };
      this.selectedDay = this.currentCaseDay; // Calendar shows current day initially
      console.log('Initialized "In" option with zero duration');
    } else {
      // For other options: use existing logic
      this.simulationTime = {
        days: this.currentCaseDay,
        hours: hours,
        minutes: minutes
      };
      this.selectedDay = this.currentCaseDay;
    }
  }

  onSimulateTimeClick() {
    if (this.isValidTimeSimulation()) {
      // Store target simulation
      this.targetSimulation = {...this.simulationTime};
      
      // If days are different, start checking conditions
      if (this.targetSimulation.days > this.currentCaseDay) {
        this.checkDayCondition();
      } else {
        this.applyTimeSimulation();
      }
    } else {
      this.showTimeError = true;
    }
  }

  checkDayCondition() {
    console.log('=== checkDayCondition Debug ===');
    console.log('Current case day:', this.currentCaseDay);
    console.log('Target simulation days:', this.targetSimulation.days);
    console.log('Case condition list:', this.caseConditionList);
    console.log('Shown conditions:', Array.from(this.shownConditions));
    
    // First check for orders that should show responses for the current day
    this.checkOrderResponsesForDay(this.currentCaseDay);
    
    // If there are pending order responses to show, show them first before checking conditions
    if (this.pendingOrderResponses.length > 0) {
      console.log('Found pending order responses for day', this.currentCaseDay, ':', this.pendingOrderResponses.length);
      this.showNextOrderResponse();
      return; // Exit here, will continue after order response is confirmed
    }
    
    // Find condition for current day - looking for conditions on the current day
    const currentDay = this.currentCaseDay;
    console.log('Looking for conditions on day:', currentDay);
    
    const dayConditions = this.caseConditionList.filter(condition => {
      console.log('Checking condition:', condition);
      console.log('Condition day:', condition.elapsedDay, 'vs current day:', currentDay);
      console.log('Condition type:', condition.caseConditionValue);
      
      const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
      const isShown = this.shownConditions.has(conditionId);
      console.log('Condition ID:', conditionId, 'Already shown:', isShown);
      
      return condition.elapsedDay === currentDay && 
             (condition.caseConditionValue === "Condition" || condition.caseConditionValue === 1 || !condition.caseConditionValue) &&
             !isShown;
    });

    console.log('Filtered day conditions:', dayConditions);

    if (dayConditions.length > 0) {
      const condition = dayConditions[0];
      console.log('Selected condition to show:', condition);
      
      // First update the time from the condition's elapsedTime
      const timeString = condition.elapsedTime || '0000';
      const hours = timeString.substring(0, 2);
      const minutes = timeString.substring(2, 4);
      
      // Update all time-related properties
      this.currentCaseTime = `${hours}:${minutes}`;
      this.simulationTime.hours = parseInt(hours);
      this.simulationTime.minutes = parseInt(minutes);
      this.currentCaseDay = condition.elapsedDay;
      
      // Calculate elapsed simulated time
      this.calculateElapsedSimulatedTime();
      
      // Check if we've reached the maximum day in case conditions
      this.checkForMaximumElapsedDay();
      
      // After time is updated, show the condition (only if case hasn't ended)
      if (!this.caseEndInstructionsShown) {
        this.currentCondition = condition.description;
        this.showConditionPopup = true;
        
        // Mark this condition as shown
        const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
        this.shownConditions.add(conditionId);
        
        console.log('Showing condition popup with:', this.currentCondition);
      }
    } else {
      console.log('No conditions found for current day, advancing...');
      
      // If no condition for current day, advance the day and check if we need to continue
      this.currentCaseDay++;
      
      // Calculate elapsed simulated time
      this.calculateElapsedSimulatedTime();
      
      // Check if we've reached the maximum day in case conditions
      this.checkForMaximumElapsedDay();
      
      if (this.currentCaseDay <= this.targetSimulation.days && !this.caseEndInstructionsShown) {
        // If we haven't reached target day and case hasn't ended, show advance confirmation
        console.log('Showing advance confirmation for next day');
        this.showAdvanceConfirmation = true;
      } else {
        // If we've reached target day or case has ended, apply final simulation
        console.log('Applying final time simulation');
        this.applyTimeSimulation();
      }
    }
  }

  onConditionConfirm() {
  
    
    this.showConditionPopup = false;
    
    // Add patient condition to progress notes
    console.log('Adding patient condition to progress notes...');
    this.addToProgressNotes('Patient Condition Update', this.currentCondition);
    console.log('Patient condition added to progress notes successfully');
    
    // Check if this is part of day-by-day continuation
    if (this.pendingDayByDayContinuation) {
      console.log('Continuing day-by-day condition processing...');
      const { day, pendingOrders, dayConditions, orderIndex, conditionIndex } = this.pendingDayByDayContinuation;
      
      // Continue processing the day content
      this.processDayContent(day, pendingOrders, dayConditions, orderIndex, conditionIndex);
      return;
    }
    
    // Check if this is part of On/In day-by-day continuation
    if (this.pendingOnInContinuation) {
      console.log('Continuing On/In day-by-day condition processing...');
      const { day, pendingOrders, dayConditions, orderIndex, conditionIndex, maxDay } = this.pendingOnInContinuation;
      
      // Continue processing the day content
      this.processOnInDayContent(day, pendingOrders, dayConditions, orderIndex, conditionIndex, maxDay);
      return;
    }
    
    // Check if this is part of "as needed" continuation (original logic)
    if (this.pendingAsNeededContinuation) {
      console.log('Continuing "as needed" sequence...');
      
      // Store the continuation data for the advance confirmation
      const { conditions, nextIndex } = this.pendingAsNeededContinuation;
      
      // Check if there are more conditions to show
      if (nextIndex < conditions.length && !this.caseEndInstructionsShown) {
        // Show the existing advance confirmation dialog
        console.log('Showing advance confirmation dialog for "as needed" continuation');
        this.showAdvanceConfirmation = true;
        // Keep the pendingAsNeededContinuation for onAdvanceConfirm to use
      } else {
        // No more conditions or case has ended, clear continuation and advance to max day
        console.log('No more conditions in "as needed" sequence, advancing to maximum day');
        this.pendingAsNeededContinuation = null;
        this.advanceToMaximumDay();
      }
      
      return; // Don't continue with normal flow for "as needed"
    }
    
    // After showing condition, ask for advance confirmation only if case hasn't ended
    if (!this.caseEndInstructionsShown) {
      console.log('Showing advance confirmation dialog');
      this.showAdvanceConfirmation = true;
    } else {
      console.log('Case has ended, not showing advance confirmation');
    }
  }

  onAdvanceConfirm(shouldContinue: boolean) {
    // Check if this is part of day-by-day continuation
    if (this.pendingDayByDayContinuation) {
      console.log('Handling day-by-day advance confirmation');
      const { day } = this.pendingDayByDayContinuation;
      
      // Close the advance confirmation dialog
      this.showAdvanceConfirmation = false;
      
      if (shouldContinue) {
        console.log('User chose to continue day-by-day simulation to day:', day);
        // Clear the current continuation and move to next day
        this.pendingDayByDayContinuation = null;
        this.simulateDayByDay(day);
      } else {
        console.log('User chose to stop day-by-day simulation - staying at current time');
        // User clicked Stop Now, just clear continuation and stay at current time
        this.pendingDayByDayContinuation = null;
        // Save case state to persist current time
        this.saveCaseState();
      }
      return;
    }
    
    // Check if this is part of On/In day-by-day continuation
    if (this.pendingOnInContinuation) {
      console.log('Handling On/In day-by-day advance confirmation');
      const { day, maxDay } = this.pendingOnInContinuation;
      
      // Close the advance confirmation dialog
      this.showAdvanceConfirmation = false;
      
      if (shouldContinue) {
        console.log('User chose to continue On/In day-by-day simulation to day:', day);
        // Clear the current continuation and move to next day
        this.pendingOnInContinuation = null;
        this.simulateOnInDayByDay(day, maxDay);
      } else {
        console.log('User chose to stop On/In day-by-day simulation - staying at current time');
        // User clicked Stop Now, just clear continuation and stay at current time
        this.pendingOnInContinuation = null;
        // Save case state to persist current time
        this.saveCaseState();
      }
      return;
    }
    
    // Check if this is part of "as needed" continuation
    if (this.pendingAsNeededContinuation) {
      console.log('Handling "as needed" advance confirmation');
      const { conditions, nextIndex } = this.pendingAsNeededContinuation;
      
      if (shouldContinue && nextIndex < conditions.length && !this.caseEndInstructionsShown) {
        console.log('User chose to continue "as needed" sequence');
        // Continue with the next condition
        this.showConditionsSequentially(conditions, nextIndex);
      } else {
        console.log('User chose to stop "as needed" sequence - staying at current time');
        // User clicked Stop Now, just clear continuation and stay at current time
        this.pendingAsNeededContinuation = null;
        this.showAdvanceConfirmation = false;
        // Save case state to persist current time
        this.saveCaseState();
      }
      return;
    }
    
    // Close the advance confirmation dialog
    this.showAdvanceConfirmation = false;
    
    // Handle user's decision for normal time advancement
    if (shouldContinue && this.currentCaseDay < this.targetSimulation.days && !this.caseEndInstructionsShown) {
      console.log('User chose to continue, advancing to next day');
      // User chose to continue, advance to next day and continue checking
      this.currentCaseDay++;
      this.checkDayCondition();
    } else {
      console.log('User chose to stop or reached target day');
      // User clicked Stop Now or we've reached the target or case has ended
      if (!shouldContinue) {
        // User clicked Stop Now - stay at current time, don't advance
        console.log('Stop Now clicked - staying at current time');
        // Save case state to persist current time
        this.saveCaseState();
      } else if (this.currentCaseDay >= this.targetSimulation.days) {
        // If we've reached target day, apply final simulation
        this.applyTimeSimulation();
      } else if (this.caseEndInstructionsShown) {
        // If case has ended, apply final simulation
        this.applyTimeSimulation();
      }
    }
  }

  isValidTimeSimulation(): boolean {
    // Convert current time to comparable values
    const currentTotal = (this.currentCaseDay * 24 * 60) + 
                        (Number(this.currentCaseTime.split(':')[0]) * 60) + 
                        Number(this.currentCaseTime.split(':')[1]);

    let targetTotal: number;

    if (this.selectedOption === 'in') {
      // For "In" option: Add duration to current time
      const targetDay = this.currentCaseDay + this.simulationTime.days;
      targetTotal = (targetDay * 24 * 60) + 
                   (this.simulationTime.hours * 60) + 
                   this.simulationTime.minutes;
      console.log('In option validation - Current:', currentTotal, 'Target:', targetTotal);
    } else {
      // For "On" and other options: Use absolute time
      targetTotal = (this.simulationTime.days * 24 * 60) + 
                   (this.simulationTime.hours * 60) + 
                   this.simulationTime.minutes;
      console.log('On option validation - Current:', currentTotal, 'Target:', targetTotal);
    }

    const isValid = targetTotal > currentTotal;
    console.log('Time validation result:', isValid);
    return isValid;
  }

  closeTimeError() {
    this.showTimeError = false;
  }

  closeNoOrdersDialog() {
    this.showNoOrdersDialog = false;
  }

  applyTimeSimulation() {
    // Update the case time with target simulation values
    const hours = this.targetSimulation.hours.toString().padStart(2, '0');
    const minutes = this.targetSimulation.minutes.toString().padStart(2, '0');
    this.currentCaseTime = `${hours}:${minutes}`;
    this.currentCaseDay = this.targetSimulation.days;
    
    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();
    
    // Check if we've reached the maximum day in case conditions
    this.checkForMaximumElapsedDay();
    
    // Check for time-based conditions on the current day (final day)
    this.checkTimeBasedConditions();
    
    // Note: Order responses are now handled day-by-day in checkDayCondition()
    // so we don't need to check them here anymore
    
    // Save case state after time simulation
    this.saveCaseState();
    
    // Close all dialogs
    this.showAdvanceConfirmation = false;
    this.showConditionPopup = false;
    this.showClockDialog = false;
  }

  checkTimeBasedConditions() {
    console.log('=== checkTimeBasedConditions Debug ===');
    console.log('Current case day:', this.currentCaseDay);
    console.log('Current case time:', this.currentCaseTime);
    
    // Convert current time to minutes for comparison
    const [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    const currentTotalMinutes = (this.currentCaseDay * 24 * 60) + (currentHours * 60) + currentMinutes;
    console.log('Current total minutes:', currentTotalMinutes);

    // Find conditions that should trigger at the current time
    const timeConditions = this.caseConditionList.filter(condition => {
      console.log('Checking time condition:', condition);
      
      // Check if condition is for current day and time
      if (condition.elapsedDay !== this.currentCaseDay) {
        console.log('Condition day mismatch:', condition.elapsedDay, 'vs', this.currentCaseDay);
        return false;
      }

      // Parse condition time
      const conditionTimeString = condition.elapsedTime || '0000';
      const conditionHours = parseInt(conditionTimeString.substring(0, 2));
      const conditionMinutes = parseInt(conditionTimeString.substring(2, 4));
      const conditionTotalMinutes = (condition.elapsedDay * 24 * 60) + (conditionHours * 60) + conditionMinutes;
      
      console.log('Condition time:', conditionTimeString, '=> total minutes:', conditionTotalMinutes);

      // Create unique identifier for this condition
      const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
      const isShown = this.shownConditions.has(conditionId);
      
      console.log('Condition ID:', conditionId, 'Already shown:', isShown);
      console.log('Time check:', conditionTotalMinutes, '<=', currentTotalMinutes, '=', conditionTotalMinutes <= currentTotalMinutes);
      console.log('Condition type:', condition.caseConditionValue);

      // Check if current time matches or exceeds condition time and hasn't been shown - removed orderId checking
      return conditionTotalMinutes <= currentTotalMinutes && 
             (condition.caseConditionValue === "Condition" || condition.caseConditionValue === 1 || !condition.caseConditionValue) &&
             !isShown;
    });

    console.log('Filtered time conditions:', timeConditions);

    // Show the most recent applicable condition
    if (timeConditions.length > 0) {
      // Sort by time and get the latest one that should have triggered
      const sortedConditions = timeConditions.sort((a, b) => {
        const aTime = parseInt(a.elapsedTime || '0000');
        const bTime = parseInt(b.elapsedTime || '0000');
        return bTime - aTime; // Descending order to get latest first
      });

      const condition = sortedConditions[0];
      console.log('Selected time condition to show:', condition);
      
      if (!this.caseEndInstructionsShown) {
        this.currentCondition = condition.description;
        this.showConditionPopup = true;
        
        // Mark this condition as shown
        const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
        this.shownConditions.add(conditionId);
        
        console.log('Showing time-based condition popup with:', this.currentCondition);
      }
    } else {
      console.log('No time-based conditions to show');
    }
  }

  checkOrderResponses() {
    if (!this.selectedOrders || this.selectedOrders.length === 0) return;

    // Convert simulated time to minutes for comparison
    const simulatedTotalMinutes = (this.targetSimulation.days * 24 * 60) + 
                                (this.targetSimulation.hours * 60) + 
                                this.targetSimulation.minutes;

    // Filter orders that should show response
    this.pendingOrderResponses = this.selectedOrders.filter(order => {
      // Skip medication orders
      if (order.orderType == 3) {
        return false;
      }

      // Handle error orders (orderType == 0) - show immediately with 1 minute advance
      if (order.orderType == 0) {
        // For error orders, check if response is available and not shown yet
        return order.response && !order.responseShown;
      }

      let orderTotalMinutes = 0;
      
      // Handle different order time formats for normal orders
      if (order.orderDay && order.orderReturnTime) {
        // New format: orderDay and orderReturnTime
        const orderDay = parseInt(order.orderDay);
        const orderHours = parseInt(order.orderReturnTime.substring(0, 2));
        const orderMinutes = parseInt(order.orderReturnTime.substring(2, 4));
        orderTotalMinutes = (orderDay * 24 * 60) + (orderHours * 60) + orderMinutes;
      } else if (order.orderTime && order.orderTime.includes('Day') && order.orderTime.includes('@')) {
        // Old format: "Day X @ HH:MM"
        const [orderHours, orderMinutes] = order.orderTime.split('@')[1].trim().split(':').map(Number);
        const orderDay = parseInt(order.orderTime.split('Day')[1].split('@')[0].trim());
        orderTotalMinutes = (orderDay * 24 * 60) + (orderHours * 60) + orderMinutes;
      } else {
        return false; // Skip orders without proper time format
      }

      return orderTotalMinutes <= simulatedTotalMinutes && order.response && !order.responseShown;
    });

    // Sort pending responses - prioritize error orders first
    this.pendingOrderResponses.sort((a, b) => {
      // Error orders (orderType == 0) come first
      if (a.orderType == 0 && b.orderType != 0) return -1;
      if (a.orderType != 0 && b.orderType == 0) return 1;
      return 0; // Keep original order for same types
    });

    // Show first response if available
    this.showNextOrderResponse();
  }

  showNextOrderResponse() {
    if (this.pendingOrderResponses.length > 0) {
      const order = this.pendingOrderResponses[0];
      
      // Check if this is an error order
      if (order.orderType == 0) {
        // For error orders, only advance clock by 1 minute (don't simulate to order time)
        this.advanceClockByOneMinute();
      }
      
      this.currentOrderResponse = order.response;
      this.currentOrderName = order.orderName;
      this.showOrderResponsePopup = true;
      
      // Mark this order as shown
      const orderIndex = this.selectedOrders.findIndex(o => o.id === order.id);
      if (orderIndex !== -1) {
        this.selectedOrders[orderIndex].responseShown = true;
        
        // Check if this is an error order and handle prerequisite cancellation
        if (order.orderType == 0) {
          this.handleErrorOrderConsequences(order);
        }
        
        // Save updated orders
        this.saveSelectedOrders();
        // Emit updated orders to trigger categorization in orders component
        this.onOrdersUpdated(this.selectedOrders);
        
        // Restore order back to available list after response is shown (after orders are updated)
        this.restoreOrderToAvailableList(order);
      }
    }
  }

  private restoreOrderToAvailableList(order: any): void {
    // Remove from selectedOrderIds to make it available for selection again
    this.selectedOrderIds = this.selectedOrderIds.filter(id => id !== order.id);
    
    // Note: We don't need to modify removedOrderIds here because that's handled
    // in the orders-popup component through the selectedOrderIds input binding
    // The orders-popup will automatically update its available orders when
    // selectedOrderIds changes through the ngOnChanges lifecycle
  }

  getLocationImage(): string {
    
    return this.locationImages[this.currentLocation] || 'assets/office.png';
  }

  getSavedOrders(): any[] {
    return this.selectedOrders || [];
  }

  onOrdersUpdated(orders: any[]): void {
    this.selectedOrders = orders;
    
    // Update selectedOrderIds array to track which orders are currently selected
    this.selectedOrderIds = orders.map(order => order.id);
    
    // Separate drug and procedure orders for console logging
    const drugOrders = orders.filter(order => order.orderType === 3);
    const procedureOrders = orders.filter(order => order.orderType === 7);
    
    // Console log the separated orders
    console.log('=== Updated Orders ===');
    console.log('All Selected Orders:', orders);
    console.log('Drug Orders (Type 3):', drugOrders);
    console.log('Procedure Orders (Type 2):', procedureOrders);
    
    // Clear cancelled orders after they've been processed
    this.cancelledOrders = [];
    
    // Only save to localStorage if we're not currently loading from saved state
    if (!this.isLoadingFromSavedState) {
      // Save updated orders to local storage
      this.saveSelectedOrders();
      // Save overall case state
      this.saveCaseState();
      
    }
  }

  // Method to handle direct order confirmations from orders-popup
  onDirectOrderConfirm(data: {order: any, isPrerequisite: boolean, drugOrders: any[], procedureOrders: any[]}): void {
    const { order, isPrerequisite, drugOrders, procedureOrders } = data;
    
    console.log('=== Direct Order Confirmation ===');
    console.log('Order:', order);
    console.log('Is Prerequisite:', isPrerequisite);
    console.log('Current Drug Orders:', drugOrders);
    console.log('Current Procedure Orders:', procedureOrders);
    
    // Add timing information to the order
    const orderWithTime = {
      ...order,
      orderTime: `Day ${this.currentCaseDay} @ ${this.currentCaseTime}`,
      reportTime: '-',
      responseShown: false
    };
    
    // Add to selected orders
    this.selectedOrders.push(orderWithTime);
    
    // Update the arrays and emit
    this.onOrdersUpdated(this.selectedOrders);
  }

  simulateClockToTime(simulationTime: any): void {
    if (!simulationTime) return;
    
    // Simulate clock to the selected time
    const hours = simulationTime.hours;
    const minutes = simulationTime.minutes;
    const days = simulationTime.days;
    
    // Your existing clock simulation logic here
    // This should use your existing simulation method
  }

  ngOnDestroy(): void {
    this.cleanupTimer();
  }

  private cleanupTimer(): void {
    if (this.realTimeTimer) {
      clearInterval(this.realTimeTimer);
      this.realTimeTimer = null;
    }
  }

  private startRealTimeTimer(): void {
    this.realTimeTimer = setInterval(() => {
      if (this.currentRealTimeInSeconds > 0) {
        this.currentRealTimeInSeconds--;
        this.updateRemainingTimeDisplay();
        
        // Save case state every 10 seconds to preserve timer state
        if (this.currentRealTimeInSeconds % 10 === 0) {
          this.saveCaseState();
        }
        
        // Check if 2 minutes (120 seconds) are left and instructions haven't been shown
        if (this.currentRealTimeInSeconds === 120 && !this.caseEndInstructionsShown) {
          this.showCaseEndInstructionsDialog();
        }
      } else {
        // Time expired
        this.cleanupTimer();
        this.showTimeExpiredDialog = true;
      }
    }, 1000); // Update every second
  }

  private updateRemainingTimeDisplay(): void {
    const minutes = Math.floor(this.currentRealTimeInSeconds / 60);
    const seconds = this.currentRealTimeInSeconds % 60;
    this.remainingTime = { minutes, seconds };
  }

  private calculateElapsedSimulatedTime(): void {
    // Convert initial time to minutes
    const [initialHours, initialMinutes] = this.initialCaseTime.split(':').map(Number);
    const initialTotalMinutes = (this.initialCaseDay * 24 * 60) + (initialHours * 60) + initialMinutes;
    
    // Convert current time to minutes
    const [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    const currentTotalMinutes = (this.currentCaseDay * 24 * 60) + (currentHours * 60) + currentMinutes;
    
    // Calculate elapsed time
    const elapsedTotalMinutes = currentTotalMinutes - initialTotalMinutes;
    
    // Convert back to days, hours, minutes
    const days = Math.floor(elapsedTotalMinutes / (24 * 60));
    const hours = Math.floor((elapsedTotalMinutes % (24 * 60)) / 60);
    const minutes = elapsedTotalMinutes % 60;
    
    this.elapsedTime = { days, hours, minutes };
  }

  onTimeExpiredConfirm(): void {
    this.showTimeExpiredDialog = false;
    // Clear saved state when case ends
    this.clearSavedState();
    // You can add additional logic here, like ending the case or showing a summary
  }

  private showCaseEndInstructionsDialog(): void {
    if (!this.caseEndInstructionsShown) {
      this.showCaseEndInstructions = true;
      this.caseEndInstructionsShown = true;
      
      // Set remaining time to exactly 2 minutes when case-end phase begins
      this.currentRealTimeInSeconds = 120; // 2 minutes
      this.updateRemainingTimeDisplay();
      
      // Save case state when entering case-end phase
      this.saveCaseState();
      
      // Close any open dialogs since case is ending
      this.showAdvanceConfirmation = false;
      this.showConditionPopup = false;
      this.showClockDialog = false;
    }
  }

  private checkForMaximumElapsedDay(): void {
    // Get the maximum elapsed day from case conditions
    const maxElapsedDay = Math.max(...this.caseConditionList.map(condition => condition.elapsedDay));
    
    // If current day is greater than max elapsed day and instructions haven't been shown
    if (this.currentCaseDay > maxElapsedDay && !this.caseEndInstructionsShown) {
      this.showCaseEndInstructionsDialog();
    }
  }

  onCaseEndInstructionsConfirm(): void {
    this.showCaseEndInstructions = false;
    this.isCaseEndPhase = true;
    // Show orders automatically
    this.showOrders = true;
    // this.showInterval = false;
    this.showLocationDialog = false;
    this.showClockDialog = false;
    
    // Save case state after confirming case-end instructions
    this.saveCaseState();
  }

  private saveSelectedOrders(): void {
    try {
     
      // localStorage.setItem(this.SELECTED_ORDERS_KEY, JSON.stringify(this.selectedOrders));
    } catch (error) {
      console.error('Error saving selected orders to localStorage:', error);
    }
  }

  private loadSelectedOrders(): void {
    try {
      const savedOrders = localStorage.getItem(this.SELECTED_ORDERS_KEY);
      if (savedOrders) {
        const parsedOrders = JSON.parse(savedOrders);
        // Only load if there are actually saved orders
        if (parsedOrders && parsedOrders.length > 0) {
          this.selectedOrders = parsedOrders;
          // Initialize selectedOrderIds when loading saved orders
          this.selectedOrderIds = parsedOrders.map((order: any) => order.id);
        }
      }
    } catch (error) {
      console.error('Error loading selected orders from localStorage:', error);
      this.selectedOrders = [];
      this.selectedOrderIds = [];
    }
  }

  private saveCaseState(): void {
    try {
      const caseState = {
        currentCaseDay: this.currentCaseDay,
        currentCaseTime: this.currentCaseTime,
        elapsedTime: this.elapsedTime,
        currentLocation: this.currentLocation,
        isCaseEndPhase: this.isCaseEndPhase,
        caseEndInstructionsShown: this.caseEndInstructionsShown,
        currentRealTimeInSeconds: this.currentRealTimeInSeconds,
        shownConditions: Array.from(this.shownConditions) // Convert Set to Array for storage
      };
      // localStorage.setItem(this.CASE_STATE_KEY, JSON.stringify(caseState));
    } catch (error) {
      console.error('Error saving case state to localStorage:', error);
    }
  }

  private loadSavedState(): void {
    this.isLoadingFromSavedState = true;
    
    this.loadSelectedOrders();
    
    try {
      const savedState = localStorage.getItem(this.CASE_STATE_KEY);
      if (savedState) {
        const caseState = JSON.parse(savedState);
        
        // Restore case state
        this.currentCaseDay = caseState.currentCaseDay || 1;
        this.currentCaseTime = caseState.currentCaseTime || '00:00';
        this.elapsedTime = caseState.elapsedTime || { days: 0, hours: 0, minutes: 0 };
        this.currentLocation = caseState.currentLocation || 'Office';
        this.isCaseEndPhase = caseState.isCaseEndPhase || false;
        this.caseEndInstructionsShown = caseState.caseEndInstructionsShown || false;
        
        // Restore shown conditions
        if (caseState.shownConditions && Array.isArray(caseState.shownConditions)) {
          this.shownConditions = new Set(caseState.shownConditions);
        } else {
          this.shownConditions = new Set();
        }
        
        // Restore timer state if case hasn't ended
        if (caseState.currentRealTimeInSeconds && caseState.currentRealTimeInSeconds > 0) {
          this.currentRealTimeInSeconds = caseState.currentRealTimeInSeconds;
          this.updateRemainingTimeDisplay();
        }
        
        
      }
    } catch (error) {
      console.error('Error loading case state from localStorage:', error);
    }
    
    // Reset the flag after loading
    setTimeout(() => {
      this.isLoadingFromSavedState = false;
    }, 200);
  }

  private clearSavedState(): void {
    try {
      localStorage.removeItem(this.SELECTED_ORDERS_KEY);
      localStorage.removeItem(this.CASE_STATE_KEY);
      // Reset shown conditions when clearing state
      this.shownConditions.clear();
    } catch (error) {
      console.error('Error clearing saved state from localStorage:', error);
    }
  }

  loadSavedOrdersManually(): void {
    this.loadSelectedOrders();
  }

  private handleNextAvailableResult(): void {
    // Check if there are any orders in selectedOrders
    if (!this.selectedOrders || this.selectedOrders.length === 0) {
      console.log('=== Next Available Result - No Orders: Using Day-by-Day Simulation ===');
      
      // Close the clock dialog first
      this.showClockDialog = false;

      // Check if maxSimulatedTime is available
      if (!this.caseData.maxSimulatedTime || this.caseData.maxSimulatedTime <= 0) {
        console.log('No maxSimulatedTime available, showing no orders dialog');
        this.showNoOrdersDialog = true;
        return;
      }

      console.log('Using maxSimulatedTime for next available result:', this.caseData.maxSimulatedTime);
      console.log('Current case day:', this.currentCaseDay);

      // Start day-by-day simulation from current day
      this.simulateDayByDay(this.currentCaseDay);
      return;
    }

    // Find the closest upcoming order
    const nextOrder = this.findClosestUpcomingOrder();

    console.log(nextOrder)
   
    if (!nextOrder) {
      // No upcoming orders found - use day-by-day simulation instead of showing popup
      console.log('=== Next Available Result - No Upcoming Orders: Using Day-by-Day Simulation ===');
      this.showClockDialog = false;

      // Check if maxSimulatedTime is available
      if (!this.caseData.maxSimulatedTime || this.caseData.maxSimulatedTime <= 0) {
        console.log('No maxSimulatedTime available, showing no orders dialog');
        this.showNoOrdersDialog = true;
        return;
      }

      console.log('Using maxSimulatedTime for no upcoming orders:', this.caseData.maxSimulatedTime);
      console.log('Current case day:', this.currentCaseDay);

      // Start day-by-day simulation from current day
      this.simulateDayByDay(this.currentCaseDay);
      return;
    }

    // Close the clock dialog
    this.showClockDialog = false;

    // Check if this is an error order
    if (nextOrder.orderType == 0) {
      // For error orders, only advance clock by 1 minute (don't simulate to order time first)
      this.advanceClockByOneMinute();
    } else {
      // For normal orders, advance clock to the order's time
      this.advanceClockToOrderTime(nextOrder);
    }

    // Then show the order response
    this.showOrderResponseDirectly(nextOrder);
  }

  private advanceClockToOrderTime(order: any): void {
    // Parse order time
    const orderDay = parseInt(order.orderDay);
    const orderHours = parseInt(order.orderReturnTime.substring(0, 2));
    const orderMinutes = parseInt(order.orderReturnTime.substring(2, 4));

    // Update the current case time and day
    this.currentCaseDay = orderDay;
    const formattedHours = orderHours.toString().padStart(2, '0');
    const formattedMinutes = orderMinutes.toString().padStart(2, '0');
    this.currentCaseTime = `${formattedHours}:${formattedMinutes}`;

    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();

    // Save case state after time advancement
    this.saveCaseState();
  }

  private findClosestUpcomingOrder(): any {
    // Convert current time to minutes for comparison
    const [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    const currentTotalMinutes = (this.currentCaseDay * 24 * 60) + (currentHours * 60) + currentMinutes;

    // Filter orders that have orderDay and orderReturnTime and are in the future
    const upcomingOrders = this.selectedOrders.filter(order => {
      // Skip medication orders
      if (order.orderType == 3) {
        return false;
      }

      if (!order.orderDay || !order.orderReturnTime) {
        return false;
      }

      // Convert order time to minutes
      const orderDay = parseInt(order.orderDay);
      const orderHours = parseInt(order.orderReturnTime.substring(0, 2));
      const orderMinutes = parseInt(order.orderReturnTime.substring(2, 4));
      const orderTotalMinutes = (orderDay * 24 * 60) + (orderHours * 60) + orderMinutes;
    
      // Only include orders that are in the future and haven't shown response yet
      return orderTotalMinutes >= currentTotalMinutes && !order.responseShown;
    });

    if (upcomingOrders.length === 0) {
      return null;
    }

    // Sort by time and return the closest one
    return upcomingOrders.sort((a, b) => {
      const aDay = parseInt(a.orderDay);
      const aHours = parseInt(a.orderReturnTime.substring(0, 2));
      const aMinutes = parseInt(a.orderReturnTime.substring(2, 4));
      const aTotalMinutes = (aDay * 24 * 60) + (aHours * 60) + aMinutes;

      const bDay = parseInt(b.orderDay);
      const bHours = parseInt(b.orderReturnTime.substring(0, 2));
      const bMinutes = parseInt(b.orderReturnTime.substring(2, 4));
      const bTotalMinutes = (bDay * 24 * 60) + (bHours * 60) + bMinutes;

      return aTotalMinutes - bTotalMinutes;
    })[0];
  }

  private showOrderResponseDirectly(order: any): void {
    // Skip medication orders
    if (order.orderType == 3) {
      return;
    }

    // For error orders, clock should already be advanced by 1 minute by the calling method
    // No additional time manipulation needed here for error orders

    if (order.response) {
      this.currentOrderResponse = order.response;
      this.currentOrderName = order.orderName;
      this.showOrderResponsePopup = true;
      
      // Mark this order as shown
      const orderIndex = this.selectedOrders.findIndex(o => o.id === order.id);
      if (orderIndex !== -1) {
        this.selectedOrders[orderIndex].responseShown = true;
        
        // Check if this is an error order and handle prerequisite cancellation
        if (order.orderType == 0) {
          this.handleErrorOrderConsequences(order);
        }
        
        // Save updated orders
        this.saveSelectedOrders();
        // Emit updated orders to trigger categorization in orders component
        this.onOrdersUpdated(this.selectedOrders);
        
        // Restore order back to available list after response is shown (after orders are updated)
        this.restoreOrderToAvailableList(order);
      }
    }
  }

  private addToProgressNotes(title: string, content: string): void {
    console.log('=== addToProgressNotes Debug ===');
    console.log('Adding to progress notes:');
    console.log('Title:', title);
    console.log('Content:', content);
    console.log('Current case time:', this.formatCaseTime());
    
    const progressNote = {
      type: title,
      time: this.formatCaseTime(),
      orderTime: this.formatCaseTime(),
      reportTime: this.formatCaseTime(),
      description: content
    };
    
    console.log('Progress note object:', progressNote);
    
    this.progressNotes.push(progressNote);
    
    console.log('Total progress notes after addition:', this.progressNotes.length);
    console.log('All progress notes:', this.progressNotes);
  }

  private addToVitalSignsHistory(vitals: any): void {
    const vitalSigns = {
      type: 'Baseline Vitals',
      time: this.formatCaseTime(),
      orderTime: this.formatCaseTime(),
      reportTime: this.formatCaseTime(),
      values: this.formatVitalsForHistory(vitals)
    };
    this.vitalSignsHistory.push(vitalSigns);
  }

  private formatVitalsForHistory(vitals: any): string {
    const temperatureF = ((vitals.temperature * 9) / 5 + 32).toFixed(1);
    const heightInInches = (vitals.height / 2.54).toFixed(1);
    const weightInLbs = (vitals.weight * 2.20462).toFixed(1);
    
    return `Temperature: ${vitals.temperature}°C (${temperatureF}°F), Pulse: ${vitals.pulse} bpm, BP: ${vitals.bpSystolic}/${vitals.bpDiastolic} mmHg, RR: ${vitals.respiratoryRate}/min, Height: ${vitals.height}cm (${heightInInches}in), Weight: ${vitals.weight}kg (${weightInLbs}lb), BMI: ${vitals.bmi}`;
  }

  showOrderResponse(order: any) {
    this.currentOrderResponse = order;
    this.showOrderResponsePopup = true;
    
    // Add order result to progress notes
    const orderTime = this.formatOrderTime(order.time);
    const orderDescription = `${order.type} - ${order.description}`;
    this.addToProgressNotes(`Order Result (${orderTime})`, orderDescription);
  }

  private formatOrderTime(timeString: string): string {
    // Format time string for display (e.g., "08:00" or "14:30")
    return timeString || 'Unknown time';
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    
    // If already navigating away (e.g., after user confirmed), allow navigation
    if (this.isNavigatingAway) {
      return true;
    }

    
    // Show confirmation dialog and return a promise
    return new Promise<boolean>((resolve) => {
      this.navigationPromiseResolve = resolve;
      this.pendingNavigation = () => {
        this.isNavigatingAway = true;
        resolve(true);
      };
      
      // Show the same confirmation dialog as the end case button
      this.showEndCaseConfirmation = true;
    });
  }



  @HostListener('document:visibilitychange', ['$event'])
  onVisibilityChange(): void {
    // This can help detect when user is trying to leave the page
    if (document.hidden && !this.isNavigatingAway) {
      // We can't show a dialog here, but we can prepare for when they return
    }
  }

  onShowVitalSigns(order: any): void {
    // Show vital signs dialog without adding to history
    // Only initial view and location changes should add to vitals history
    
    // If the order has vital signs values, format them for display
    if (order.values) {
      // Use the existing formatted values
      this.vitalContent = `<div class="style3"><b>Vital Signs</b><br><br><p>${order.values}</p></div>`;
    } else {
      // Fallback to baseline vitals if no specific values
      this.vitalContent = this.generateVitalsTable(JSON.parse(this.caseData.baseline_vitals));
    }
    
    this.showVitalsDialog = true;
  }

  onShowProgressNote(data: {response: string, title: string}): void {
    // Show progress note response in a dialog
    console.log('Showing progress note:', data);
    this.currentOrderResponse = data.response;
    this.currentOrderName = data.title;
    this.showOrderResponsePopup = true;
  }

  onShowOrderResult(data: {response: string, title: string}): void {
    // Show order result response in a dialog
    console.log('Showing order result:', data);
    this.currentOrderResponse = data.response;
    this.currentOrderName = data.title;
    this.showOrderResponsePopup = true;
  }

  private calculateOrderTiming(orders: any[]): void {
    if (!orders || orders.length === 0) return;

    // Parse current simulation time
    const [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    
    orders.forEach(order => {
      // Skip return time calculation for medication orders
      if (order.orderType == 3) {
        return; // Skip this order and continue with next one
      }

      // Check if order has prerequisites
      const hasPrerequisites = order.prerequisiteOrder && order.prerequisiteOrder.trim() !== '';
      
      if (hasPrerequisites) {
        // Use cumulative timing for orders with prerequisites
        this.calculateCumulativeOrderTiming(order, orders, currentHours, currentMinutes);
      } else {
        // Use simple timing for orders without prerequisites
        this.calculateSimpleOrderTiming(order, currentHours, currentMinutes);
      }
    });
  }

  // New method for simple order timing (current logic)
  private calculateSimpleOrderTiming(order: any, currentHours: number, currentMinutes: number): void {
    // Check if order has return time structure (when backend provides it)
    let orderReturnTimeStructure = {
      days: 0,    // Default 0 day
      hours: 0,   // Default 0 hours  
      minutes: 0  // Default 0 minutes
    };
    
    // If order already has a return time structure from backend, use it
    if (order.orderReturnTime) {
      try {
        orderReturnTimeStructure = JSON.parse(order.orderReturnTime);
      } catch (e) {
        console.error('Error parsing orderReturnTime:', e);
      }
    }
    
    // Calculate orderDay = current day + orderReturnTime.days
    order.orderDay = this.currentCaseDay + orderReturnTimeStructure.days;
    
    // Calculate return time = current time + (hours and minutes)
    const totalMinutes = (currentHours * 60) + currentMinutes + 
                        (orderReturnTimeStructure.hours * 60) + 
                        orderReturnTimeStructure.minutes;
    
    let returnHours = Math.floor(totalMinutes / 60);
    let returnMinutes = totalMinutes % 60;
    
    // Handle day overflow (if time goes beyond 24 hours)
    if (returnHours >= 24) {
      const extraDays = Math.floor(returnHours / 24);
      order.orderDay += extraDays;
      returnHours = returnHours % 24;
    }
    
    // Format return time as "HHMM" string
    const formattedHours = returnHours.toString().padStart(2, '0');
    const formattedMinutes = returnMinutes.toString().padStart(2, '0');
    order.orderReturnTime = `${formattedHours}${formattedMinutes}`;
  }

  // New method for cumulative order timing (prerequisite-based)
  private calculateCumulativeOrderTiming(order: any, allOrders: any[], currentHours: number, currentMinutes: number): void {
    const visited = new Set<number>(); // Prevent infinite loops
    const cumulativeDuration = this.calculateCumulativeDuration(order, allOrders, visited);
    
    console.log(`=== Cumulative Timing for Order: ${order.orderName} (ID: ${order.id}) ===`);
    console.log('Total cumulative duration:', cumulativeDuration);
    
    // Start with current time in minutes
    let totalMinutes = (currentHours * 60) + currentMinutes + cumulativeDuration.totalMinutes;
    let currentDay = this.currentCaseDay + cumulativeDuration.totalDays;
    
    // Handle minute and hour overflow
    let returnHours = Math.floor(totalMinutes / 60);
    let returnMinutes = totalMinutes % 60;
    
    // Handle day overflow (if time goes beyond 24 hours)
    if (returnHours >= 24) {
      const extraDays = Math.floor(returnHours / 24);
      currentDay += extraDays;
      returnHours = returnHours % 24;
    }
    
    // Set calculated values
    order.orderDay = currentDay;
    const formattedHours = returnHours.toString().padStart(2, '0');
    const formattedMinutes = returnMinutes.toString().padStart(2, '0');
    order.orderReturnTime = `${formattedHours}${formattedMinutes}`;
    
    console.log(`Final timing - Day: ${order.orderDay}, Time: ${order.orderReturnTime}`);
  }

  // New method to calculate cumulative duration including all prerequisites
  private calculateCumulativeDuration(order: any, allOrders: any[], visited: Set<number>): {totalDays: number, totalMinutes: number} {
    // Prevent infinite loops
    if (visited.has(order.id)) {
      console.warn(`Circular dependency detected for order ${order.id}`);
      return { totalDays: 0, totalMinutes: 0 };
    }
    visited.add(order.id);
    
    let totalDays = 0;
    let totalMinutes = 0;
    
    // Get this order's own duration
    let orderDuration = { days: 0, hours: 0, minutes: 0 };
    if (order.orderReturnTime) {
      try {
        orderDuration = JSON.parse(order.orderReturnTime);
      } catch (e) {
        console.error('Error parsing orderReturnTime for order:', order.id, e);
      }
    }
    
    // Add this order's duration
    totalDays += orderDuration.days;
    totalMinutes += (orderDuration.hours * 60) + orderDuration.minutes;
    
    console.log(`Order ${order.orderName} own duration: ${orderDuration.days} days, ${orderDuration.hours} hours, ${orderDuration.minutes} minutes`);
    
    // Get prerequisite order IDs
    const prerequisiteIds = this.parsePrerequisites(order);
    
    if (prerequisiteIds.length > 0) {
      console.log(`Order ${order.orderName} has prerequisites:`, prerequisiteIds);
      
      // For each prerequisite, recursively calculate its cumulative duration
      prerequisiteIds.forEach(prerequisiteId => {
        const prerequisiteOrder = allOrders.find(o => o.id === prerequisiteId);
        if (prerequisiteOrder) {
          console.log(`Processing prerequisite: ${prerequisiteOrder.orderName} (ID: ${prerequisiteId})`);
          const prerequisiteDuration = this.calculateCumulativeDuration(prerequisiteOrder, allOrders, new Set(visited));
          totalDays += prerequisiteDuration.totalDays;
          totalMinutes += prerequisiteDuration.totalMinutes;
          console.log(`Added prerequisite duration: ${prerequisiteDuration.totalDays} days, ${prerequisiteDuration.totalMinutes} minutes`);
        } else {
          console.warn(`Prerequisite order with ID ${prerequisiteId} not found in order list`);
        }
      });
    } else {
      console.log(`Order ${order.orderName} has no prerequisites`);
    }
    
    // Handle minute overflow to days
    if (totalMinutes >= 24 * 60) {
      const extraDays = Math.floor(totalMinutes / (24 * 60));
      totalDays += extraDays;
      totalMinutes = totalMinutes % (24 * 60);
    }
    
    console.log(`Total cumulative duration for ${order.orderName}: ${totalDays} days, ${totalMinutes} minutes`);
    return { totalDays, totalMinutes };
  }

  // New method to handle cancelled orders
  onOrderCancelled(cancelledOrder: any): void {
    // Add the cancelled order to the cancelled orders array
    this.cancelledOrders.push(cancelledOrder);
    
    // Remove from selected order IDs
    this.selectedOrderIds = this.selectedOrderIds.filter(id => id !== cancelledOrder.id);
    
    // Save the updated state
    this.saveSelectedOrders();
  }

  onOrderResponseConfirm() {
    this.showOrderResponsePopup = false;
    
    // Check if this is part of day-by-day continuation
    if (this.pendingDayByDayContinuation) {
      console.log('Continuing day-by-day order processing...');
      const { day, pendingOrders, dayConditions, orderIndex, conditionIndex } = this.pendingDayByDayContinuation;
      
      // Continue processing the day content
      this.processDayContent(day, pendingOrders, dayConditions, orderIndex, conditionIndex);
      return;
    }
    
    // Check if this is part of On/In day-by-day continuation
    if (this.pendingOnInContinuation) {
      console.log('Continuing On/In day-by-day order processing...');
      const { day, pendingOrders, dayConditions, orderIndex, conditionIndex, maxDay } = this.pendingOnInContinuation;
      
      // Continue processing the day content
      this.processOnInDayContent(day, pendingOrders, dayConditions, orderIndex, conditionIndex, maxDay);
      return;
    }
    
    // Original logic for non day-by-day flow
    // Remove the confirmed order from pending responses
    this.pendingOrderResponses.shift();
    
    // Check if there are more order responses for the current selected orders
    if (this.pendingOrderResponses.length > 0) {
      console.log('Showing next order response for current day');
      this.showNextOrderResponse();
    } else {
      console.log('All order responses for current day shown, showing advance confirmation');
      // All order responses for current day are shown, show advance confirmation
      if (!this.caseEndInstructionsShown) {
        this.showAdvanceConfirmation = true;
      } else {
        // If case has ended, apply final simulation
        this.applyTimeSimulation();
      }
    }
  }

  private handleAsNeededOption(): void {
    console.log('=== New Day-by-Day As Needed Option ===');
    
    // Close the clock dialog first
    this.showClockDialog = false;

    // Check if maxSimulatedTime is available
    if (!this.caseData.maxSimulatedTime || this.caseData.maxSimulatedTime <= 0) {
      console.log('No maxSimulatedTime available, falling back to old logic');
      this.handleAsNeededOptionFallback();
      return;
    }

    console.log('Using maxSimulatedTime:', this.caseData.maxSimulatedTime);
    console.log('Current case day:', this.currentCaseDay);

    // Start day-by-day simulation from current day
    this.simulateDayByDay(this.currentCaseDay);
  }

  private handleAsNeededOptionFallback(): void {
    // Original logic as fallback
    const remainingConditions = this.caseConditionList.filter(condition => {
      const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
      const isShown = this.shownConditions.has(conditionId);
      const isConditionType = condition.caseConditionValue === "Condition" || condition.caseConditionValue === 1 || !condition.caseConditionValue;
      
      return !isShown && isConditionType;
    });

    if (remainingConditions.length === 0) {
      this.advanceToMaximumDay();
      return;
    }

    const sortedConditions = remainingConditions.sort((a, b) => {
      if (a.elapsedDay !== b.elapsedDay) {
        return a.elapsedDay - b.elapsedDay;
      }
      const aTime = parseInt(a.elapsedTime || '0000');
      const bTime = parseInt(b.elapsedTime || '0000');
      return aTime - bTime;
    });

    this.showConditionsSequentially(sortedConditions, 0);
  }

  private simulateDayByDay(dayToSimulate: number): void {
    console.log('=== Simulating Day:', dayToSimulate, '===');
    
    // Check if we've reached the maximum simulation time
    if (dayToSimulate > this.caseData.maxSimulatedTime) {
      console.log('Reached maximum simulation time, ending simulation');
      this.advanceToFinalDay();
      return;
    }

    // Update current case day and time to start of the day
    this.currentCaseDay = dayToSimulate;
    this.currentCaseTime = '00:00';
    this.simulationTime.hours = 0;
    this.simulationTime.minutes = 0;
    
    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();
    
    // Save case state
    this.saveCaseState();

    // Step 1: Check for pending orders for this day
    this.checkOrderResponsesForDay(dayToSimulate);
    
    // Step 2: Find case conditions for this day
    const dayConditions = this.caseConditionList.filter(condition => {
      const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
      const isShown = this.shownConditions.has(conditionId);
      const isConditionType = condition.caseConditionValue === "Condition" || condition.caseConditionValue === 1 || !condition.caseConditionValue;
      
      return condition.elapsedDay === dayToSimulate && !isShown && isConditionType;
    });

    // Sort conditions by time
    const sortedDayConditions = dayConditions.sort((a, b) => {
      const aTime = parseInt(a.elapsedTime || '0000');
      const bTime = parseInt(b.elapsedTime || '0000');
      return aTime - bTime;
    });

    console.log('Pending orders for day', dayToSimulate, ':', this.pendingOrderResponses);
    console.log('Conditions for day', dayToSimulate, ':', sortedDayConditions);

    // Step 3: Process day content (orders first, then conditions, then advance confirmation)
    this.processDayContent(dayToSimulate, [...this.pendingOrderResponses], sortedDayConditions, 0, 0);
  }

  private handleOnInDayByDaySimulation(maxDay: number, targetSimulation: any): void {
    console.log('=== Starting On/In Day-by-Day Simulation ===');
    console.log('Max day:', maxDay, 'Target simulation:', targetSimulation);
    
    // Store the target simulation for final application
    this.targetSimulation = targetSimulation;
    
    // Start with the next day after current
    this.simulateOnInDayByDay(this.currentCaseDay + 1, maxDay);
  }

  private simulateOnInDayByDay(dayToSimulate: number, maxDay: number): void {
    console.log('=== Simulating On/In Day:', dayToSimulate, 'of max:', maxDay, '===');
    
    // Check if we've reached the target day
    if (dayToSimulate > maxDay) {
      console.log('Reached target day, applying final simulation');
      this.applyTimeSimulation();
      return;
    }

    // Update current case day to start of the day  
    this.currentCaseDay = dayToSimulate;
    this.currentCaseTime = '00:00';
    this.simulationTime.hours = 0;
    this.simulationTime.minutes = 0;
    
    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();
    
    // Save case state
    this.saveCaseState();

    // Step 1: Check for pending orders for this day
    this.checkOrderResponsesForDay(dayToSimulate);
    
    // Step 2: Find case conditions for this day
    const dayConditions = this.caseConditionList.filter(condition => {
      const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
      const isShown = this.shownConditions.has(conditionId);
      const isConditionType = condition.caseConditionValue === "Condition" || condition.caseConditionValue === 1 || !condition.caseConditionValue;
      
      return condition.elapsedDay === dayToSimulate && !isShown && isConditionType;
    });

    // Sort conditions by time
    const sortedDayConditions = dayConditions.sort((a, b) => {
      const aTime = parseInt(a.elapsedTime || '0000');
      const bTime = parseInt(b.elapsedTime || '0000');
      return aTime - bTime;
    });

    console.log('Pending orders for day', dayToSimulate, ':', this.pendingOrderResponses);
    console.log('Conditions for day', dayToSimulate, ':', sortedDayConditions);

    // Step 3: Process day content (orders first, then conditions, then advance confirmation)
    this.processOnInDayContent(dayToSimulate, [...this.pendingOrderResponses], sortedDayConditions, 0, 0, maxDay);
  }

  private processDayContent(
    day: number, 
    pendingOrders: any[], 
    dayConditions: any[], 
    orderIndex: number, 
    conditionIndex: number
  ): void {
    console.log('=== Processing Day Content ===');
    console.log('Day:', day, 'Order index:', orderIndex, 'Condition index:', conditionIndex);
    console.log('Pending orders:', pendingOrders.length, 'Day conditions:', dayConditions.length);

    // Step 1: Show pending orders first (one by one)
    if (orderIndex < pendingOrders.length) {
      const order = pendingOrders[orderIndex];
      console.log('Showing order response:', order.orderName);
      
      // Show the order response
      this.currentOrderResponse = order.response;
      this.currentOrderName = order.orderName;
      this.showOrderResponsePopup = true;
      
      // Mark this order as shown
      const orderInSelectedIndex = this.selectedOrders.findIndex(o => o.id === order.id);
      if (orderInSelectedIndex !== -1) {
        this.selectedOrders[orderInSelectedIndex].responseShown = true;
        
        // Handle error orders
        if (order.orderType == 0) {
          this.handleErrorOrderConsequences(order);
        }
        
        this.saveSelectedOrders();
        this.onOrdersUpdated(this.selectedOrders);
        this.restoreOrderToAvailableList(order);
      }
      
      // Store continuation data for onOrderResponseConfirm
      this.pendingDayByDayContinuation = {
        day: day,
        pendingOrders: pendingOrders,
        dayConditions: dayConditions,
        orderIndex: orderIndex + 1,
        conditionIndex: conditionIndex
      };
      
      return;
    }

    // Step 2: Show case conditions (one by one)
    if (conditionIndex < dayConditions.length) {
      const condition = dayConditions[conditionIndex];
      console.log('Showing condition:', condition.description);
      
      // Update time to the condition's time
      const timeString = condition.elapsedTime || '0000';
      const hours = timeString.substring(0, 2);
      const minutes = timeString.substring(2, 4);
      
      this.currentCaseTime = `${hours}:${minutes}`;
      this.simulationTime.hours = parseInt(hours);
      this.simulationTime.minutes = parseInt(minutes);
      
      // Calculate elapsed simulated time
      this.calculateElapsedSimulatedTime();
      
      // Show the condition
      this.currentCondition = condition.description;
      this.showConditionPopup = true;
      
      // Mark this condition as shown
      const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
      this.shownConditions.add(conditionId);
      
      // Add to progress notes
      this.addToProgressNotes('Patient Condition Update', this.currentCondition);
      
      // Store continuation data for onConditionConfirm
      this.pendingDayByDayContinuation = {
        day: day,
        pendingOrders: pendingOrders,
        dayConditions: dayConditions,
        orderIndex: orderIndex,
        conditionIndex: conditionIndex + 1
      };
      
      return;
    }

    // Step 3: All orders and conditions shown, show advance confirmation
    console.log('All content shown for day', day, ', showing advance confirmation');
    this.showAdvanceConfirmation = true;
    
    // Store continuation data for onAdvanceConfirm
    this.pendingDayByDayContinuation = {
      day: day + 1,
      pendingOrders: [],
      dayConditions: [],
      orderIndex: 0,
      conditionIndex: 0
    };
  }

  private processOnInDayContent(
    day: number, 
    pendingOrders: any[], 
    dayConditions: any[], 
    orderIndex: number, 
    conditionIndex: number, 
    maxDay: number
  ): void {
    console.log('=== Processing On/In Day Content ===');
    console.log('Day:', day, 'Order index:', orderIndex, 'Condition index:', conditionIndex, 'Max day:', maxDay);
    console.log('Pending orders:', pendingOrders.length, 'Day conditions:', dayConditions.length);

    // Step 1: Show pending orders first (one by one)
    if (orderIndex < pendingOrders.length) {
      const order = pendingOrders[orderIndex];
      console.log('Showing order response:', order.orderName);
      
      // Show the order response
      this.currentOrderResponse = order.response;
      this.currentOrderName = order.orderName;
      this.showOrderResponsePopup = true;
      
      // Mark this order as shown
      const orderInSelectedIndex = this.selectedOrders.findIndex(o => o.id === order.id);
      if (orderInSelectedIndex !== -1) {
        this.selectedOrders[orderInSelectedIndex].responseShown = true;
        
        // Handle error orders
        if (order.orderType == 0) {
          this.handleErrorOrderConsequences(order);
        }
        
        this.saveSelectedOrders();
        this.onOrdersUpdated(this.selectedOrders);
        this.restoreOrderToAvailableList(order);
      }
      
      // Store special continuation data for On/In options
      this.pendingOnInContinuation = {
        day: day,
        pendingOrders: pendingOrders,
        dayConditions: dayConditions,
        orderIndex: orderIndex + 1,
        conditionIndex: conditionIndex,
        maxDay: maxDay
      };
      
      return;
    }

    // Step 2: Show case conditions (one by one)
    if (conditionIndex < dayConditions.length) {
      const condition = dayConditions[conditionIndex];
      console.log('Showing condition:', condition.description);
      
      // Update time to the condition's time
      const timeString = condition.elapsedTime || '0000';
      const hours = timeString.substring(0, 2);
      const minutes = timeString.substring(2, 4);
      
      this.currentCaseTime = `${hours}:${minutes}`;
      this.simulationTime.hours = parseInt(hours);
      this.simulationTime.minutes = parseInt(minutes);
      
      // Calculate elapsed simulated time
      this.calculateElapsedSimulatedTime();
      
      // Show the condition
      this.currentCondition = condition.description;
      this.showConditionPopup = true;
      
      // Mark this condition as shown
      const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
      this.shownConditions.add(conditionId);
      
      // Add to progress notes
      this.addToProgressNotes('Patient Condition Update', this.currentCondition);
      
      // Store special continuation data for On/In options
      this.pendingOnInContinuation = {
        day: day,
        pendingOrders: pendingOrders,
        dayConditions: dayConditions,
        orderIndex: orderIndex,
        conditionIndex: conditionIndex + 1,
        maxDay: maxDay
      };
      
      return;
    }

    // Step 3: All orders and conditions shown, show advance confirmation
    console.log('All content shown for day', day, ', showing advance confirmation');
    this.showAdvanceConfirmation = true;
    
    // Store special continuation data for On/In options  
    this.pendingOnInContinuation = {
      day: day + 1,
      pendingOrders: [],
      dayConditions: [],
      orderIndex: 0,
      conditionIndex: 0,
      maxDay: maxDay
    };
  }

  private advanceToFinalDay(): void {
    console.log('=== Advancing to Final Day ===');
    
    // Set to the maximum simulation day
    this.currentCaseDay = this.caseData.maxSimulatedTime;
    this.currentCaseTime = '23:59';
    this.simulationTime.hours = 23;
    this.simulationTime.minutes = 59;
    
    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();
    
    // Check for maximum elapsed day to trigger case-end logic
    this.checkForMaximumElapsedDay();
    
    // Save case state
    this.saveCaseState();
  }

  private showConditionsSequentially(conditions: any[], index: number): void {
    console.log('=== showConditionsSequentially Debug ===');
    console.log('Showing condition at index:', index);
    console.log('Total conditions:', conditions.length);

    // If we've shown all conditions, advance to maximum day and end
    if (index >= conditions.length) {
      console.log('All conditions shown, advancing to maximum day');
      this.advanceToMaximumDay();
      return;
    }

    const condition = conditions[index];
    console.log('Current condition to show:', condition);

    // Update time to the condition's time
    const timeString = condition.elapsedTime || '0000';
    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2, 4);
    
    // Update all time-related properties
    this.currentCaseTime = `${hours}:${minutes}`;
    this.simulationTime.hours = parseInt(hours);
    this.simulationTime.minutes = parseInt(minutes);
    this.currentCaseDay = condition.elapsedDay;
    
    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();
    
    // Check if we've reached the maximum day in case conditions
    this.checkForMaximumElapsedDay();
    
    // Show the condition (only if case hasn't ended)
    if (!this.caseEndInstructionsShown) {
      this.currentCondition = condition.description;
      this.showConditionPopup = true;
      
      // Mark this condition as shown
      const conditionId = condition.id || condition.elapsedDay * 10000 + parseInt(condition.elapsedTime || '0000');
      this.shownConditions.add(conditionId);
      
      console.log('Showing condition popup with:', this.currentCondition);
      
      // Store the continuation logic for when user confirms this condition
      this.pendingAsNeededContinuation = {
        conditions: conditions,
        nextIndex: index + 1
      };
    } else {
      console.log('Case has ended, stopping condition display');
    }
  }

  private advanceToMaximumDay(): void {
    console.log('=== advanceToMaximumDay Debug ===');
    
    // Get the maximum elapsed day from case conditions
    const maxElapsedDay = Math.max(...this.caseConditionList.map(condition => condition.elapsedDay));
    console.log('Maximum elapsed day:', maxElapsedDay);
    
    // Advance beyond the maximum day to trigger case-end logic
    // The existing checkForMaximumElapsedDay() only triggers when currentCaseDay > maxElapsedDay
    this.currentCaseDay = maxElapsedDay + 1;
    
    // Set time to start of the next day (00:00)
    this.currentCaseTime = '00:00';
    this.simulationTime.hours = 0;
    this.simulationTime.minutes = 0;
    
    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();
    
    console.log('Advanced beyond maximum day to:', this.currentCaseDay, 'at time:', this.currentCaseTime);
    
    // Use the existing functionality to check if case should end
    // This will trigger the case-end instructions popup since currentCaseDay > maxElapsedDay
    this.checkForMaximumElapsedDay();
    
    // Save case state
    this.saveCaseState();
  }

  // New method to check if an order is an error order
  private isErrorOrder(order: any): boolean {
    return order.orderType === 0;
  }

  // New method to advance clock by exactly 1 minute
  private advanceClockByOneMinute(): void {
    // Parse current time
    const [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    
    // Add 1 minute
    let newMinutes = currentMinutes + 1;
    let newHours = currentHours;
    let newDay = this.currentCaseDay;
    
    // Handle minute overflow
    if (newMinutes >= 60) {
      newMinutes = 0;
      newHours++;
    }
    
    // Handle hour overflow
    if (newHours >= 24) {
      newHours = 0;
      newDay++;
    }
    
    // Update current case time and day
    this.currentCaseDay = newDay;
    const formattedHours = newHours.toString().padStart(2, '0');
    const formattedMinutes = newMinutes.toString().padStart(2, '0');
    this.currentCaseTime = `${formattedHours}:${formattedMinutes}`;
    
    // Calculate elapsed simulated time
    this.calculateElapsedSimulatedTime();
    
    // Save case state after time advancement
    this.saveCaseState();
    
    console.log(`Advanced clock by 1 minute to: Day ${this.currentCaseDay} @ ${this.currentCaseTime}`);
  }

  // New method to parse prerequisite orders from string (copied from orders-popup component)
  private parsePrerequisites(order: any): number[] {
    if (!order.prerequisiteOrder || order.prerequisiteOrder.trim() === '') {
      return [];
    }
    
    try {
      // First try to parse as JSON array (e.g., "[198351,729662,430830]")
      if (order.prerequisiteOrder.startsWith('[') && order.prerequisiteOrder.endsWith(']')) {
        const parsedArray = JSON.parse(order.prerequisiteOrder);
        if (Array.isArray(parsedArray)) {
          return parsedArray.map(id => parseInt(id)).filter(id => !isNaN(id));
        }
      }
      
      // Fallback: Handle comma-separated IDs (e.g., "198351,729662,430830")
      return order.prerequisiteOrder
        .split(',')
        .map(id => parseInt(id.trim()))
        .filter(id => !isNaN(id));
    } catch (e) {
      console.error('Error parsing prerequisite orders:', e);
      return [];
    }
  }

  // New method to find all orders that depend on a given prerequisite order
  private findDependentOrders(prerequisiteOrderId: number): any[] {
    const dependentOrders: any[] = [];
    const visited = new Set<number>(); // Prevent infinite loops
    
    const findDependentsRecursively = (orderId: number) => {
      if (visited.has(orderId)) {
        return; // Prevent infinite loops
      }
      visited.add(orderId);
      
      // Find direct dependents of this order
      const directDependents = this.selectedOrders.filter(order => {
        const prerequisiteIds = this.parsePrerequisites(order);
        return prerequisiteIds.includes(orderId);
      });
      
      // Add direct dependents and recursively find their dependents
      directDependents.forEach(dependent => {
        if (!dependentOrders.some(existing => existing.id === dependent.id)) {
          dependentOrders.push(dependent);
          // Recursively find orders that depend on this dependent order
          findDependentsRecursively(dependent.id);
        }
      });
    };
    
    findDependentsRecursively(prerequisiteOrderId);
    return dependentOrders;
  }

  // New method to handle consequences of error orders
  private handleErrorOrderConsequences(errorOrder: any): void {
    console.log('=== Handling Error Order Consequences ===');
    console.log('Error order:', errorOrder.orderName, 'ID:', errorOrder.id);
    
    // Check if this error order is a prerequisite for any other orders
    const dependentOrders = this.findDependentOrders(errorOrder.id);
    
    if (dependentOrders.length > 0) {
      console.log('Found dependent orders that will be cancelled:', 
        dependentOrders.map(order => `${order.orderName} (ID: ${order.id})`));
      
      // Cancel all dependent orders
      this.cancelDependentOrders(dependentOrders);
    } else {
      console.log('No dependent orders found for this error order');
    }
  }

  // New method to cancel dependent orders
  private cancelDependentOrders(dependentOrders: any[]): void {
    console.log('=== Cancelling Dependent Orders ===');
    
    // Remove dependent orders from selectedOrders array
    const orderIdsToRemove = dependentOrders.map(order => order.id);
    this.selectedOrders = this.selectedOrders.filter(order => 
      !orderIdsToRemove.includes(order.id)
    );
    
    // Update selectedOrderIds to remove cancelled orders
    this.selectedOrderIds = this.selectedOrderIds.filter(id => 
      !orderIdsToRemove.includes(id)
    );
    
    // Add cancelled orders to the cancelled orders list for potential restoration
    dependentOrders.forEach(order => {
      this.cancelledOrders.push(order);
      // Emit cancellation event for each order
      this.onOrderCancelled(order);
    });
    
    console.log('Cancelled orders:', dependentOrders.map(order => order.orderName));
    console.log('Remaining selected orders:', this.selectedOrders.map(order => order.orderName));
    
    // Save updated state
    this.saveSelectedOrders();
    this.saveCaseState();
  }

  checkOrderResponsesForDay(dayToCheck: number) {
    if (!this.selectedOrders || this.selectedOrders.length === 0) {
      this.pendingOrderResponses = [];
      return;
    }

    console.log('=== checkOrderResponsesForDay Debug ===');
    console.log('Checking orders for day:', dayToCheck);
    console.log('Selected orders:', this.selectedOrders);

    // Convert day to minutes for comparison (end of day comparison)
    const dayTotalMinutes = (dayToCheck * 24 * 60) + (23 * 60) + 59; // End of the day

    // Filter orders that should show response for this specific day
    this.pendingOrderResponses = this.selectedOrders.filter(order => {
      // Skip medication orders
      if (order.orderType == 3) {
        return false;
      }

      // Handle error orders (orderType == 0) - show immediately with 1 minute advance
      if (order.orderType == 0) {
        // For error orders, check if response is available and not shown yet
        return order.response && !order.responseShown;
      }

      let orderTotalMinutes = 0;
      
      // Handle different order time formats for normal orders
      if (order.orderDay && order.orderReturnTime) {
        // New format: orderDay and orderReturnTime
        const orderDay = parseInt(order.orderDay);
        
        // Only show orders that are due on this specific day
        if (orderDay !== dayToCheck) {
          return false;
        }
        
        const orderHours = parseInt(order.orderReturnTime.substring(0, 2));
        const orderMinutes = parseInt(order.orderReturnTime.substring(2, 4));
        orderTotalMinutes = (orderDay * 24 * 60) + (orderHours * 60) + orderMinutes;
      } else if (order.orderTime && order.orderTime.includes('Day') && order.orderTime.includes('@')) {
        // Old format: "Day X @ HH:MM"
        const orderDay = parseInt(order.orderTime.split('Day')[1].split('@')[0].trim());
        
        // Only show orders that are due on this specific day
        if (orderDay !== dayToCheck) {
          return false;
        }
        
        const [orderHours, orderMinutes] = order.orderTime.split('@')[1].trim().split(':').map(Number);
        orderTotalMinutes = (orderDay * 24 * 60) + (orderHours * 60) + orderMinutes;
      } else {
        return false; // Skip orders without proper time format
      }

      const shouldShow = orderTotalMinutes <= dayTotalMinutes && order.response && !order.responseShown;
      console.log('Order:', order.orderName, 'Day:', dayToCheck, 'Should show:', shouldShow);
      return shouldShow;
    });

    // Sort pending responses - prioritize error orders first
    this.pendingOrderResponses.sort((a, b) => {
      // Error orders (orderType == 0) come first
      if (a.orderType == 0 && b.orderType != 0) return -1;
      if (a.orderType != 0 && b.orderType == 0) return 1;
      return 0; // Keep original order for same types
    });

    console.log('Pending order responses for day', dayToCheck, ':', this.pendingOrderResponses);
  }

  onExitCase(diagnosis: string): void {
    console.log('Exit case requested with diagnosis:', diagnosis);
    
    // Clear saved state
    this.clearSavedState();
    
    // Navigate back to case selection
    this.isNavigatingAway = true;
    this.router.navigate(['/ccs-module'], { 
      queryParams: { section: 'interactive-cases' } 
    });
  }

  private cleanupThankYouTimer(): void {
    if (this.thankYouTimer) {
      clearTimeout(this.thankYouTimer);
      this.thankYouTimer = null;
    }
  }
} 